<div class="modal-header">
  <button type="button" class="close"
   aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<template #dialogContainer>
</template>
